<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  styleClass="inactivity-alert-dialog"
  [style]="{width: '350px'}"
  [showHeader]="false">
  
  <div class="inactivity-alert-content">
    <div class="alert-icon">
      <i class="pi pi-clock"></i>
    </div>
    
    <div class="alert-title">
      {{ 'TiempoInactividadAlerta' | translate }}
    </div>
    
    <div class="alert-message">
      {{ 'MensajeInactividadDetallado' | translate }}
    </div>
    
    <div class="countdown-container">
      <div class="countdown-circle">
        <span class="countdown-number">{{ countdownDisplay }}</span>
      </div>
      <div class="countdown-text">
        {{ 'SegundosRestantes' | translate }}
      </div>
    </div>
    
    <div class="alert-actions">
      <p-button 
        label="{{ 'ContinuarSesion' | translate }}" 
        (onClick)="continueSession()"
        styleClass="p-button-primary">
      </p-button>
    </div>
  </div>
</p-dialog>
